<div class="min-h-full px-6 py-24 flex flex-col justify-center items-center text-center">
  <p class="text-base font-bold text-indigo-600 dark:text-indigo-400">404</p>

  <h1 class="mt-4 text-5xl font-extrabold tracking-tight text-balance text-slate-900 sm:text-7xl dark:text-white">Pagina non trovata</h1>

  <p class="mt-6 text-lg font-medium text-pretty text-slate-600 sm:text-xl/8 dark:text-gray-400 max-w-xl">
    Siamo spiacenti, non siamo riusciti a trovare la pagina che cercavi.
  </p>

  <div class="mt-10 flex items-center justify-center gap-x-6">
    <a routerLink="/" class="rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-bold text-white shadow-sm shadow-slate-900/5
    hover:bg-indigo-500 transition-all cursor-pointer">
      Torna alla Home
    </a>
    <a routerLink="/aiuto/contatti" class="text-sm font-bold text-slate-700 hover:text-indigo-600 dark:text-gray-300 dark:hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
      Contatta il Supporto
      <i class="fa-solid fa-arrow-right text-xs"></i>
    </a>
  </div>
</div>
